import { createSlice, PayloadAction } from "@reduxjs/toolkit";



import {
    createProject, deleteBrandVoice, deleteProject, editBrandVoice, getBrandVoice, getProjects, saveBrandVoice, saveCompanyDetails,
    saveExcludedLinks, saveProjectInstructions,
    updateProject,
} from "./thunks";

import {
    ProjectState, ProjectType
} from "./types";

const initialLoadingState = {
    ["projects/create"]: "idle",
    ["projects/requested"]: "idle",
    ["projects/update"]: "idle",
    ["projects/delete"]: "idle",
    ["projects/getBrandVoice"]: "idle",
    ["projects/saveBrandVoice"]: "idle",
    ["projects/editBrandVoice"]: "idle",
    ["projects/deleteBrandVoice"]: "idle",
    ["projects/saveCompanyDetails"]: "idle",
    ["projects/saveExcludedLinks"]: "idle",
    ["projects/saveProjectInstructions"]: "idle",

};



const initialState = {
    entities: [],
    brandVoice: '',
    loading: initialLoadingState,
    error: null,
    message: { type: "", message: "", requestType: "" },
    companyDetails: {
        companyName: "",
        companyInformation: "",
        productInformation: "",
        targetAudience: "",
    },





    fulfilled: false,
} as ProjectState;




const projectsSlice = createSlice({
    name: "projects",
    initialState,
    reducers: {
        reset: () => initialState,
        resetMessage: (state) => {
            state.message = { type: "", message: "", requestType: "" };
        },
        addProject: (state, action: PayloadAction<ProjectType>) => {
            state.entities.push(action.payload);
        },
        editProject: (state, action: PayloadAction<ProjectType>) => {
            state.entities.push(action.payload);
        },
        deleteproject: (state, action: PayloadAction<string>) => {
            state.entities = state.entities.filter((project) => project.projectId !== action.payload);
        },
        getAllProjects: (state, action: PayloadAction<ProjectType[]>) => {
            state.entities = action.payload;
        },
        createBrandVoice: (state, action: PayloadAction<string>) => {
        },
        addBrandVoice: (state, action: PayloadAction<string>) => {
            state.brandVoice = action.payload;
        },
        modifyBrandVoice: (state, action: PayloadAction<string>) => {
            state.brandVoice = action.payload;
        },
        removeBrandVoice: (state, action: PayloadAction<string>) => {
            state.brandVoice = action.payload;
        },
        createCompanyDetails: (state, action:PayloadAction<string>) => {

        },




    },

    extraReducers: (builder) => {
        builder.addCase(createProject.pending, (state, action) => {
            state.loading["projects/create"] = "pending";
        });
        builder.addCase(createProject.fulfilled, (state, action) => {
            state.loading["projects/create"] = "finished";
            state.fulfilled = true;
            state.message = action.payload.error ? { type: "error", message: action.payload.error, requestType:'createProject' } : { type: "success", message: "Project created successfully", requestType:'createProject' };
            if(!action.payload.error){
            state.entities.push(action.payload);
            }
        });
        builder.addCase(createProject.rejected, (state, action) => {
            state.loading["projects/create"] = "finished";
            state.error = action.error.message || null;
        });
        builder.addCase(getProjects.pending, (state, action) => {
            state.loading["projects/requested"] = "pending";
        }
        );
        builder.addCase(getProjects.fulfilled, (state, action) => {
            state.loading["projects/requested"] = "finished";
            state.entities = action.payload.projectData;
        }
        );
        builder.addCase(getProjects.rejected, (state, action) => {
            state.loading["projects/requested"] = "finished";
            state.error = action.error.message || null;
        }

        );
        builder.addCase(updateProject.pending, (state, action) => {
            state.loading["projects/update"] = "pending";
        }
        );
        builder.addCase(updateProject.fulfilled, (state, action) => {
            state.loading["projects/update"] = "finished";
            state.fulfilled = true;
            state.message = action.payload.error ? { type: "error", message: action.payload.error, requestType:'updateProject' } : { type: "success", message: "Project Updated Successfully" , requestType:'updateProject'};

            // state.entities.push(action.payload);
        }
        );
        builder.addCase(updateProject.rejected, (state, action) => {
            state.loading["projects/update"] = "finished";
            state.error = action.error.message || null;
        }

        );

        builder.addCase(deleteProject.pending, (state, action) => {
            state.loading["projects/delete"] = "pending";
        }
        );
        builder.addCase(deleteProject.fulfilled, (state, action) => {
            state.loading["projects/delete"] = "finished";
            state.fulfilled = true;
            state.message = action.payload.error ? { type: "error", message: action.payload.error, requestType:'deleteProject' } : { type: "success", message: "Project Deleted Successfully", requestType:'deleteProject' };

            state.entities = state.entities.filter((project) => project.projectId !== action.payload.projectId);
        }
        );
        builder.addCase(deleteProject.rejected, (state, action) => {
            state.loading["projects/delete"] = "finished";
            state.error = action.error.message || null;
        }

        );
        //get brand voice
        builder.addCase(getBrandVoice.pending, (state, action) => {
            state.loading["projects/getBrandVoice"] = "pending";
        }
        );

        builder.addCase(getBrandVoice.fulfilled, (state, action) => {
            state.loading["projects/getBrandVoice"] = "finished";
            state.fulfilled = true;
            state.message = action.payload.error ? { type: "error", message: action.payload.error, requestType:'getBrandVoice' } : { type: "success", message: "Brand Voice Fetched Successfully", requestType:'getBrandVoice' };

            state.brandVoice = action.payload.brandVoice;
        }
        );
        builder.addCase(getBrandVoice.rejected, (state, action) => {
            state.loading["projects/getBrandVoice"] = "finished";
            state.error = action.error.message || null;
        }
        );

        //save brand voice
        builder.addCase(saveBrandVoice.pending, (state, action) => {
            state.loading["projects/saveBrandVoice"] = "pending";
        }
        );

        builder.addCase(saveBrandVoice.fulfilled, (state, action) => {
            state.loading["projects/saveBrandVoice"] = "finished";
            state.fulfilled = true;
            state.message = action.payload.error ? { type: "error", message: action.payload.error, requestType:'saveBrandVoice' } : { type: "success", message: "Brand Voice Saved Successfully", requestType:'saveBrandVoice' };
        }
        );
        builder.addCase(saveBrandVoice.rejected, (state, action) => {
            state.loading["projects/SavebrandVoice"] = "finished";
            state.error = action.error.message || null;
        }
        );

        //edit brand voice
        builder.addCase(editBrandVoice.pending, (state, action) => {
            state.loading["projects/editBrandVoice"] = "pending";
        }
        );

        builder.addCase(editBrandVoice.fulfilled, (state, action) => {
            state.loading["projects/editBrandVoice"] = "finished";
            state.fulfilled = true;
            state.message = action.payload.error ? { type: "error", message: action.payload.error, requestType:'editBrandVoice' } : { type: "success", message: "Brand Voice Edited Successfully", requestType:'editBrandVoice' };
        }
        );
        builder.addCase(editBrandVoice.rejected, (state, action) => {

            state.loading["projects/editBrandVoice"] = "finished";
            state.error = action.error.message || null;
        }
        );

        //delete brand voice

        builder.addCase(deleteBrandVoice.pending, (state, action) => {
            state.loading["projects/deleteBrandVoice"] = "pending";
        }
        );

        builder.addCase(deleteBrandVoice.fulfilled, (state, action) => {

            state.loading["projects/deleteBrandVoice"] = "finished";
            state.fulfilled = true;
            state.message = action.payload.error ? { type: "error", message: action.payload.error,requestType:'deleteBrandVoice' } : { type: "success", message: "Brand Voice Deleted Successfully", requestType:'deleteBrandVoice' };
        }
        );
        builder.addCase(deleteBrandVoice.rejected, (state, action) => {
            state.loading["projects/deleteBrandVoice"] = "finished";
            state.error = action.error.message || null;
        }
        );

        //save companyDetails
        builder.addCase(saveCompanyDetails.pending, (state, action) => {
            state.loading["projects/saveCompanyDetails"] = "pending";
        }
        );

        builder.addCase(saveCompanyDetails.fulfilled, (state, action) => {
            state.loading["projects/saveCompanyDetails"] = "finished";
            state.fulfilled = true;
            state.message = action.payload.error ? { type: "error", message: action.payload.error,requestType:'saveCompanyDetails' } : { type: "success", message: "Company Details Saved Successfully", requestType:'saveCompanyDetails' };
        }
        );
        builder.addCase(saveCompanyDetails.rejected, (state, action) => {
            state.loading["projects/saveCompanyDetails"] = "finished";
            state.error = action.error.message || null;
        }
        );


        //save excluded links
        builder.addCase(saveExcludedLinks.pending, (state, action) => {
            state.loading["projects/saveExcludedLinks"] = "pending";
        }
        );

        builder.addCase(saveExcludedLinks.fulfilled, (state, action) => {
            state.loading["projects/saveExcludedLinks"] = "finished";
            state.fulfilled = true;
            state.message = action.payload.error ? { type: "error", message: action.payload.error,requestType:'saveExcludedLinks' } : { type: "success", message: "Excluded Links Saved Successfully", requestType:'saveExcludedLinks' };
        }
        );

        builder.addCase(saveExcludedLinks.rejected, (state, action) => {
            state.loading["projects/saveExcludedLinks"] = "finished";
            state.error = action.error.message || null;
        }
        );

        //save project instructions
        builder.addCase(saveProjectInstructions.pending, (state, action) => {
            state.loading["projects/saveProjectInstructions"] = "pending";
        });

        builder.addCase(saveProjectInstructions.fulfilled, (state, action) => {
            state.loading["projects/saveProjectInstructions"] = "finished";
            state.fulfilled = true;
            state.message = action.payload.error ? { type: "error", message: action.payload.error, requestType: 'saveProjectInstructions' } : { type: "success", message: "Instructions Saved Successfully", requestType: 'saveProjectInstructions' };
        });

        builder.addCase(saveProjectInstructions.rejected, (state, action) => {
            state.loading["projects/saveProjectInstructions"] = "finished";
            state.error = action.error.message || null;
        });

    }
});

export const {
    reset,
    addProject,
    editProject,
    deleteproject,
    getAllProjects,
    resetMessage,
    createBrandVoice,
    modifyBrandVoice,
    removeBrandVoice,
    createCompanyDetails,
    // addBriefToProject,
    // removeBriefFromProject,
    // moveBriefInProject,
} = projectsSlice.actions;
export * from "./selectors";
export * from "./thunks";
export * from "./types";
export default projectsSlice.reducer;